import styles from './GradeQuestion.module.css';
import {ReactComponent as GO_BACK} from "../../images/go-back-purple.svg";
import {decodeCIParam, getResponseStatus, questionCodeToName} from "../../utils/questionUtils";
import React, {useEffect, useRef, useState} from "react";
import { ASCII_CODE_A, BLANK_REGEX, FIXED_ANSWER, GRADE_BOOK_RESPONSE_STATUS, POLL_TYPE, QUESTION_TYPES, RESPONSIVE_SIDE_BAR_POINT } from "../../utils/constants";
import {
    getAnswer, getQuestionCorrectnessPoints, getQuestionParticipationPoints, getQuestionWeightage,
    handleUserAns, hasCorrectness, hasWeightage, isManualGradeQue,
    notifyError,
    notifySuccess, questionHasCorrectness, questionHasWeightage,
} from "../../utils/helpers";
import YuJaButton from "../../components/standardization/YuJaButton";
import { ReactComponent as SAVE } from "../../images/Save.svg";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import { ReactComponent as NON_POSTED_ICON } from "../../images/grade-question-not-posted-icon.svg";
import { ReactComponent as NON_GRADABLE_ICON } from "../../images/grade-question-non-gradable-icon.svg";
import { ReactComponent as UN_ANSWERED_ICON } from "../../images/grade-question-unanswered-icon.svg";
import { ReactComponent as CORRECT_ICON } from "../../images/grade-question-correct-icon.svg";
import { ReactComponent as INCORRECT_ICON } from "../../images/grade-question-incorrect-icon.svg";
import { ReactComponent as ARROW_LEFT_ICON } from "../../images/arrow-left-purple.svg";
import { ReactComponent as ARROW_RIGHT_ICON } from "../../images/arrow-right-purple.svg";

import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {YuJaRadioBox} from "../../components/standardization/YuJaRadiobox";
import reactStringReplace from "react-string-replace";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import loadingGif from "../../images/LoadingAnimation.gif";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import ReactDOM from "react-dom";
import {LatexInline} from "../../components/Tiptap/latexParser";
import parse from "html-react-parser";
import {Button} from "@base-ui/react/button";
import YuJaSelect from "../../components/standardization/YuJaSelect";
import YuJaComboBox from "../../components/standardization/YuJaComboBox";
import { useTranslation } from "react-i18next";


export default function GradeQuestionNew({
                                             institutionId,
                                             pollKey,
                                             pollCode,
                                             pollType,
                                             pollShareMode,
                                             startTime,
                                             loadData,
                                             open=false,
                                             setOpen,
                                             questions,
                                             responses,
                                             userId,
                                             attemptNo,
                                             serialNo=1,
                                         }) {
    const { t } = useTranslation();
    const {width} = useWindowDimensions();
    const { gradeQuestionStudents} = ResponseApiCalls();

    const parentContainerRef = useRef();
    const [curUserId, setCurUserId] = useState(userId);
    const [curResponse, setCurResponse] = useState(responses.find(r => r.userId === userId));
    const [curAttemptNo, setCurAttemptNo] = useState(attemptNo);
    const students = responses.map(r => ({ label: `${r.firstName}${r.lastName ? " " + r.lastName : ""}`, value: `${r.userId}` }));
    let totalScore = questions.reduce(function (result, q) {
        return result + getQuestionWeightage(q);
    }, 0);

    const [selectedSerialNo, setSelectedSerialNo] = useState(serialNo);
    const [selectedQuestion, setSelectedQuestion] = useState(questions.find(q => q.serialNo === selectedSerialNo));
    const [questionImageURL, setQuestionImageURL] = useState("");
    const [isVideo, setIsVideo] = useState(false);
    const [imageWidth, setImageWidth] = useState(1);
    const [imageHeight, setImageHeight] = useState(1);
    const [isLoaded, setIsLoaded] = useState(false);
    const [selectedQuestionResponseStatus, setSelectedQuestionResponseStatus] = useState({});
    const [changes, setChanges] = useState({});
    const [alertGradeShow, setGradeAlertShow] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [scored, setScored] = useState("0");
    const [percentage, setPercentage] = useState("0%")


    const gradeAlertConfig = {
        title: t("poll.unsavedChangesTitle"),
        okText: t("common.yes"),
        cancelText: t("common.cancel"),
        submit: async () => {
            setChanges({});
            setGradeAlertShow(false);
            setOpen(false);
        },
        close: async () => {
            setGradeAlertShow(false);
        },
        buttonWidth: "77px"
    };

    const onLoad = (e) => {
        setIsLoaded(true);
        setImageWidth(e.target.width);
        setImageHeight(e.target.height);
    }


    useEffect(() => {
        const container = document.getElementsByTagName('main')[0];

        if (!container) {
            return;
        }

        if (!!open) {
            // Find all elements with tabindex="0" inside the container
            const tabbableElements = container.querySelectorAll('[tabindex="0"]');

            // Set tabindex="-1" for each element
            tabbableElements.forEach(element => {
                element.setAttribute('tabindex', '-1');
            });

        }

        return () => {
            const tabbableElements = container.querySelectorAll('[tabindex="-1"]');

            // Set tabindex="-1" for each element
            tabbableElements.forEach(element => {
                element.setAttribute('tabindex', '0');
            });
        }


    }, [open]);

    useEffect(() => {
        let response = responses.find(r => r.userId === curUserId);
        setCurResponse(response);
    }, [curUserId]);


    useEffect(() => {
        let que = questions.find(q => q.serialNo === selectedSerialNo);
        setSelectedQuestion(que);
        setIsLoaded(false);
        if(que.directLinkEvp) {
            setQuestionImageURL(que.directLinkEvp);
            setIsVideo(true);
        } else {
            setQuestionImageURL(que.imageURL);
            setIsVideo(false);
        }
    }, [selectedSerialNo]);

    useEffect(() => {
        let scored = (!!curResponse.attempts
            && !!curResponse.attempts.hasOwnProperty(`${curAttemptNo}`)
            && curResponse.attempts[curAttemptNo].hasOwnProperty("correctCount")
            && curResponse.attempts[curAttemptNo].correctCount)
            ? curResponse.attempts[curAttemptNo].correctCount
            : '0';

        setScored(`${scored}/${totalScore}`);
        setPercentage((!!curResponse.attempts
            && !!curResponse.attempts.hasOwnProperty(`${curAttemptNo}`)
            && curResponse.attempts[curAttemptNo].hasOwnProperty("score")
            && parseFloat(curResponse.attempts[curAttemptNo].score))
            ? `${curResponse.attempts[curAttemptNo].score}`
            : '0');
    }, [curResponse, curAttemptNo]);


    useEffect(() => {
        const {serialNo} = selectedQuestion;
        const {attempts=[]} = curResponse;
        let attempt = attempts[curAttemptNo];
        let actualAnswer = !!attempt ? attempt[`A${serialNo}`] : undefined;
        let formattedResponse = !!attempt ? attempt[`Q${serialNo}`] : undefined;

        let status = getResponseStatus({pollType, pollShareMode, startTime}, selectedQuestion, actualAnswer, formattedResponse);
        setSelectedQuestionResponseStatus(status);
    }, [selectedQuestion, curAttemptNo, curResponse, pollType, pollShareMode, startTime]);

    const renderAnswer = () => {
        const { serialNo, questionType, weightage, optionsMap, optionsImageMap={}, correctAnswers=[]} = selectedQuestion;
        const {attempts=[]} = curResponse;
        const answer = attempts.hasOwnProperty(`${curAttemptNo}`) ? attempts[curAttemptNo][`A${serialNo}`] : null;
        const isAnswered = selectedQuestionResponseStatus.key !== GRADE_BOOK_RESPONSE_STATUS.UNANSWERED.key
            && !!answer
            && answer !== FIXED_ANSWER.UNANSWERED;

        const gradeEnabled = !!weightage && pollType?.toUpperCase() !== POLL_TYPE.SURVEY;
        const isActualCorrect = handleUserAns(selectedQuestion, isAnswered ? answer : FIXED_ANSWER.UNANSWERED);
        const showCorrectAnswer = gradeEnabled && !isActualCorrect;
        // const showCorrectAnswer = gradeEnabled && !isActualCorrect && !isManualGradeQue(true, questionType);



        if (selectedQuestionResponseStatus.key === GRADE_BOOK_RESPONSE_STATUS.NOT_POSTED.key) {
            return (
                <div>
                    <span className={styles.regularLabel}>{t("common.answerLabel")}: </span>
                    <span className={styles.regularText}>-</span>
                </div>
            );
        }

        switch (questionType) {
            case QUESTION_TYPES.MCSS.name:
                return (
                    <>
                        <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                            <span className={styles.regularLabel}>{t("common.answerLabel")}: </span>
                            {Object.keys(optionsMap).map((optIdx, index) => {
                                const isSelected = !!answer ? (Array.isArray(answer) ? answer.includes(optIdx) : answer === optIdx) : false;
                                if (!!gradeEnabled) {
                                    return (
                                        <div
                                            key={index}
                                            className={`${styles.optionBar} 
                                        ${isSelected ? (correctAnswers.includes(optIdx) ? styles.correct : styles.incorrect) : ""}`}
                                        >
                                            {!!isSelected && correctAnswers.includes(optIdx) &&
                                                <span className={`${styles.indexIconContainer} ${styles.correct}`}>
                                                <CORRECT_ICON/>
                                            </span>
                                            }

                                            {!!isSelected && !correctAnswers.includes(optIdx) &&
                                                <span className={`${styles.indexIconContainer} ${styles.incorrect}`}>
                                                <INCORRECT_ICON/>
                                            </span>
                                            }

                                            {!isSelected &&
                                                <span className={styles.indexIconContainer}/>
                                            }
                                            <LatexInline>{optionsMap[optIdx]}</LatexInline>



                                            {optionsImageMap.hasOwnProperty(optIdx) && !!optionsImageMap[optIdx].imageURL &&
                                                <div className="MCSS-opt-image-container" style={{width: 30, height: 30, borderRadius: 3}} >
                                                    <img
                                                        alt={t("accessibility.optionImagePreview", {option: optIdx})}
                                                        src={`${optionsImageMap[optIdx].imageURL}`}
                                                        style={ { maxWidth: "100%", maxHeight: "100%"}}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div
                                            key={index}
                                            className={`${styles.optionBar} ${isSelected ? styles.selected : ""}`}
                                        >
                                        <span className={`${styles.indexIconContainer} ${isSelected ? styles.selected : ""}`}>
                                            {optIdx.toUpperCase()}
                                        </span>
                                            <LatexInline>{optionsMap[optIdx]}</LatexInline>
                                        </div>
                                    );
                                }
                            })}
                        </div>

                        {!!showCorrectAnswer &&
                            <div style={{display: "flex", gap: 5}}>
                                <span className={styles.regularLabel}>{t("gradebook.correctAnswerTitle")}: </span>
                                <div style={{display: "flex", flexDirection: "column", gap: 5}}>
                                    {correctAnswers
                                        .sort((a, b) => a.localeCompare(b))
                                        .map((optIdx, index) =>
                                            <span key={index} className={styles.regularText} style={{fontWeight: "500"}}>
                                                {optIdx.toUpperCase()}. <LatexInline>{optionsMap[optIdx]}</LatexInline>
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                    </>
                );
            case QUESTION_TYPES.TF.name:
                return (
                    <>
                        <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                            <span className={styles.regularLabel}>{t("common.answerLabel")}: </span>
                            {optionsMap.map((option, index) => {
                                const isSelected = !!answer ? answer === option : false;
                                if (!!gradeEnabled) {
                                    return (
                                        <div
                                            key={index}
                                            className={`${styles.optionBar} 
                                        ${isSelected ? (correctAnswers === option ? styles.correct : styles.incorrect) : ""}`}
                                        >
                                            {!!isSelected && correctAnswers === option &&
                                                <span className={`${styles.indexIconContainer} ${styles.correct}`}>
                                                    <CORRECT_ICON/>
                                                </span>
                                            }

                                            {!!isSelected && !correctAnswers === option &&
                                                <span className={`${styles.indexIconContainer} ${styles.incorrect}`}>
                                                    <INCORRECT_ICON/>
                                                </span>
                                            }

                                            {!isSelected &&
                                                <span className={styles.indexIconContainer}/>
                                            }
                                            {option}
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div
                                            key={index}
                                            className={`${styles.optionBar} ${isSelected ? styles.selected : ""}`}
                                        >
                                            {option}
                                        </div>
                                    );
                                }
                            })}
                        </div>

                        {!!showCorrectAnswer &&
                            <div style={{display: "flex", gap: 5}}>
                                <span className={styles.regularLabel}>{t("gradebook.correctAnswerTitle")}: </span>
                                <span className={styles.regularText} style={{fontWeight: "500"}}>{correctAnswers}</span>
                            </div>
                        }
                    </>
                );
            case QUESTION_TYPES.SA.name:
            case QUESTION_TYPES.IB.name:
            case QUESTION_TYPES.RETRO.name:
            case QUESTION_TYPES.BS.name:
                return (
                    <span
                        className={styles.regularLabel}
                        style={{gap: 5, display: "flex", alignItems: "center"}}
                    >
                        <span>{t("common.answerLabel")}:</span>
                        {!isAnswered &&
                            <span
                                className={styles.optionBar}
                                style={{width: "fit-content", color: "#000"}}
                            >
                                <span className={styles.indexIconContainer} style={{width: 24, height: 24}}>
                                    <UN_ANSWERED_ICON style={{width: 18, height: 18}}/>
                                </span>
                                {t("gradebook.statusUnanswered")}
                            </span>
                        }
                        {!!isAnswered &&
                            <span className={styles.regularText}>
                                {getAnswer(curResponse, curAttemptNo, selectedQuestion.serialNo)}
                            </span>
                        }
                    </span>
                );
            case QUESTION_TYPES.OE.name:
                return (
                    <span
                        className={styles.regularLabel}
                        style={{gap: 5, display: "flex", alignItems: "center"}}
                    >
                        <span >{t("common.answerLabel")}:</span>
                        {!isAnswered &&
                            <span
                                className={styles.optionBar}
                                style={{width: "fit-content", color: "#000"}}
                            >
                                <span className={styles.indexIconContainer} style={{width: 24, height: 24}}>
                                    <UN_ANSWERED_ICON style={{width: 18, height: 18}}/>
                                </span>
                                {t("gradebook.statusUnanswered")}
                            </span>
                        }
                        {!!isAnswered &&
                            <span className={styles.regularText}>
                                {getAnswer(curResponse, curAttemptNo, selectedQuestion.serialNo)}
                            </span>
                        }
                    </span>
                );
            case QUESTION_TYPES.FITB.name:
                let blankNameArr = Object.keys(correctAnswers).map(str => `\\(${str}\\)`);
                const regex = new RegExp(`(${blankNameArr.join("|")})`, "g");
                console.log(1234)
                return (
                    <>
                       <span className={styles.regularLabel} style={{marginRight: 5, lineHeight: "unset"}}>
                          <span>{t("common.answerLabel")}:</span>
                          <span className={styles.regularText} style={{lineHeight: "unset"}}>
                               {reactStringReplace(selectedQuestion.queTitle, regex, (blank, i, o) => {
                                   const match = !!blank ? blank.match(/\(([^)]+)\)/) : null;
                                   if (!match) {
                                       return "";
                                   }
                                   const blankName = match[1];

                                   if (!isAnswered) {
                                       return (
                                           <span style={{display: "inline-block", verticalAlign: "middle"}}>
                                               <span
                                                   className={styles.optionBar}
                                                   style={{width: "fit-content", padding: "5px 10px", margin: 2}}
                                               >
                                                   <span className={styles.indexIconContainer}>
                                                        <UN_ANSWERED_ICON style={{width: 16, height: 16}}/>
                                                    </span>
                                                   {t("gradebook.statusUnanswered")}
                                               </span>
                                           </span>
                                       );
                                   } else if (!gradeEnabled) {
                                       return (
                                           <span style={{display: "inline-block", verticalAlign: "middle"}}>
                                               <span
                                                   className={styles.optionBar}
                                                   style={{width: "fit-content", padding: "5px 10px", margin: 2}}
                                               >
                                                   {answer[blankName]}
                                               </span>
                                           </span>
                                       );
                                   } else if (correctAnswers[blankName].includes(answer[blankName])) {
                                       return (
                                           <span style={{display: "inline-block", verticalAlign: "middle"}}>
                                               <span
                                                   className={`${styles.optionBar} ${styles.correct}`}
                                                   style={{width: "fit-content", padding: "5px 10px", margin: 2}}
                                               >
                                                   <span className={`${styles.indexIconContainer} ${styles.correct}`}>
                                                       <CORRECT_ICON/>
                                                   </span>
                                                   {answer[blankName]}
                                               </span>
                                           </span>
                                       );
                                   } else {
                                       return (
                                           <span style={{display: "inline-block", verticalAlign: "middle"}}>
                                               <span
                                                   className={`${styles.optionBar} ${styles.incorrect}`}
                                                   style={{width: "fit-content", padding: "5px 10px", margin: 2}}
                                               >
                                                   <span className={`${styles.indexIconContainer} ${styles.incorrect}`}>
                                                       <INCORRECT_ICON/>
                                                   </span>
                                                   {answer[blankName]}
                                               </span>
                                           </span>
                                       );
                                   }
                               })}
                          </span>
                       </span>

                       {!!showCorrectAnswer &&
                           <div style={{display: "flex", gap: 5}}>
                               <span className={styles.regularLabel}>{t("gradebook.correctAnswerTitle")}: </span>
                               <span style={{display: "flex", flexDirection: "column", gap: 5}}>
                                   {Object.keys(correctAnswers).map((key, index) => (
                                       <span key={index} className={styles.regularText} style={{fontWeight: "500"}}>
                                           {t("gradebook.blankNumber", {number: index + 1})}. {correctAnswers[key].join(", ")}
                                       </span>
                                   ))}
                               </span>

                           </div>
                       }
                   </>
               );
            case QUESTION_TYPES.CI.name:
                return (
                    <>
                        <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                            <span className={styles.regularLabel}>{t("common.answerLabel")}: </span>
                            {optionsMap.map((option, index) => {
                                const isSelected = !!answer ? (answer.selected === `${index}`) : false;
                                if (!!gradeEnabled) {
                                    return (
                                        <div
                                            key={index}
                                            className={`${styles.optionBar} 
                                            ${isSelected ? (correctAnswers.includes(index) ? styles.correct : styles.incorrect) : ""}`}
                                        >
                                            {!!isSelected && correctAnswers.includes(index) &&
                                                <span className={`${styles.indexIconContainer} ${styles.correct}`}>
                                                <CORRECT_ICON/>
                                            </span>
                                            }

                                            {!!isSelected && !correctAnswers.includes(index) &&
                                                <span className={`${styles.indexIconContainer} ${styles.incorrect}`}>
                                                <INCORRECT_ICON/>
                                            </span>
                                            }

                                            {!isSelected &&
                                                <span className={styles.indexIconContainer}/>
                                            }

                                            <LatexInline>{option.text}</LatexInline>

                                            {optionsImageMap.hasOwnProperty(answer) && !!optionsImageMap[answer].imageURL &&
                                                <div className="MCSS-opt-image-container" style={{width: 30, height: 30, borderRadius: 3}} >
                                                    <img
                                                        alt={t("accessibility.optionImagePreview", {option: answer})}
                                                        src={`${optionsImageMap[answer].imageURL}`}
                                                        style={ { maxWidth: "100%", maxHeight: "100%"}}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className={`${styles.optionBar} ${isSelected ? styles.selected : ""}`}>
                                            <span className={`${styles.indexIconContainer} ${isSelected ? styles.selected : ""}`}>
                                                {String.fromCharCode(ASCII_CODE_A + index)}
                                            </span>
                                            <LatexInline>{option.text}</LatexInline>
                                        </div>
                                    );
                                }
                            })}

                            {!!answer && answer.selected === "other" &&
                                <div className={`${styles.optionBar} ${!!gradeEnabled ? styles.incorrect : styles.selected}`}>
                                    {!!gradeEnabled &&
                                        <span className={`${styles.indexIconContainer} ${styles.incorrect}`}>
                                            <INCORRECT_ICON/>
                                        </span>
                                    }
                                    {t("poll.feedbackCategoryOther")}
                                </div>
                            }
                        </div>
                        {!!showCorrectAnswer &&
                            <div style={{display: "flex", gap: 5}}>
                                <span className={styles.regularLabel}>{t("gradebook.correctAnswerTitle")}: </span>
                                <div style={{display: "flex", flexDirection: "column", gap: 5}}>
                                    {correctAnswers.map((optIdx, index) =>
                                        <span key={index} className={styles.regularText} style={{fontWeight: "500"}}>
                                            {String.fromCharCode(ASCII_CODE_A + optIdx)}. <LatexInline>{optionsMap[optIdx].text}</LatexInline>
                                        </span>
                                    )}
                                </div>
                            </div>
                        }
                    </>
                );
            case QUESTION_TYPES.MH.name:
                return (
                    <>
                        <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                            <div style={{display: "flex", gap: 10}}>
                                <span className={styles.regularLabel} style={{flex: 1}}>
                                    {t("gradebook.premisesLabel")}
                                </span>
                                <span className={styles.regularLabel} style={{flex: 1}}>
                                    {t("gradebook.responsesLabel")}
                                </span>
                            </div>

                            <div style={{display: "flex", gap: 10}}>
                                <div style={{flex: 1, display: "flex", flexDirection: "column", gap: 8}}>
                                    {correctAnswers.filter(i => i.length > 1).map((key, index) =>
                                        <div key={index} className={styles.optionBar}>
                                            <span className={styles.indexIconContainer}>{index + 1}</span>
                                            <LatexInline>{key[0]}</LatexInline>
                                        </div>
                                    )}
                                </div>
                                <div style={{flex: 1, display: "flex", flexDirection: "column", gap: 8}}>
                                    {correctAnswers.filter(i => i.length > 1).map((key, index) =>
                                        <div
                                            key={index}
                                            className={`${styles.optionBar} 
                                            ${!!isAnswered ? (answer.hasOwnProperty(index) && key[1] === answer[index] ? styles.correct : styles.incorrect) : ""}`}
                                        >
                                            {!!isAnswered && answer.hasOwnProperty(index) && key[1] === answer[index] &&
                                                <span className={`${styles.indexIconContainer} ${styles.correct}`}>
                                                    <CORRECT_ICON/>
                                                </span>
                                            }

                                            {!!isAnswered && answer.hasOwnProperty(index) && key[1] !== answer[index] &&
                                                <span className={`${styles.indexIconContainer} ${styles.incorrect}`}>
                                                    <INCORRECT_ICON/>
                                                </span>
                                            }

                                            {(!isAnswered || !answer.hasOwnProperty(index)) &&
                                                <span className={styles.indexIconContainer}/>
                                            }
                                            {!!isAnswered && answer.hasOwnProperty(index)
                                                ? <LatexInline>{!!answer[index] ? answer[index] : "-"}</LatexInline>
                                                : "-"
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>

                            {!!showCorrectAnswer &&
                                <div style={{display: "flex", gap: 5}}>
                                    <span className={styles.regularLabel}>{t("gradebook.correctAnswerTitle")}: </span>
                                    <div style={{display: "flex", flexDirection: "column", gap: 5}}>
                                        {correctAnswers.filter(i => i.length > 1).map((key, index) =>
                                            <span
                                                key={index}
                                                className={styles.regularText}
                                                style={{fontWeight: "500"}}
                                            >
                                                <LatexInline>{key[0]}</LatexInline>
                                                &nbsp;&nbsp;{"->"}&nbsp;&nbsp;
                                                <LatexInline>{key[1]}</LatexInline>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                );
            case QUESTION_TYPES.RK.name:
                return (
                    <>
                        <span className={styles.regularLabel} style={{gap: 5, display: "flex", alignItems: "center"}}>
                            <span>{t("common.answerLabel")}:</span>
                            {!isAnswered &&
                                <span className={styles.optionBar} style={{width: "fit-content", color: "#000"}}>
                                    <span className={styles.indexIconContainer} style={{width: 24, height: 24}}>
                                        <UN_ANSWERED_ICON style={{width: 18, height: 18}}/>
                                    </span>
                                    {t("gradebook.statusUnanswered")}
                                </span>
                            }
                        </span>
                        {isAnswered &&
                            <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                                {answer.map((key, index) =>
                                    <div key={index} className={styles.optionBar}>
                                        <span
                                            className={`${styles.indexIconContainer}`}
                                            style={{width: "auto", padding: 5}}
                                        >
                                            {t("poll.rankText") + " " + (index + 1)}
                                        </span>
                                        <LatexInline>{key}</LatexInline>
                                    </div>
                                )}
                            </div>
                        }
                    </>
                );
            case QUESTION_TYPES.WC.name:

                return (
                    <>
                        <span className={styles.regularLabel} style={{gap: 5, display: "flex", alignItems: "center"}}>
                            <span>{t("common.answerLabel")}:</span>
                            {!isAnswered &&
                                <span className={styles.optionBar} style={{width: "fit-content", color: "#000"}}>
                                    <span className={styles.indexIconContainer} style={{width: 24, height: 24}}>
                                        <UN_ANSWERED_ICON style={{width: 18, height: 18}}/>
                                    </span>
                                    {t("gradebook.statusUnanswered")}
                                </span>
                            }
                        </span>
                        {isAnswered &&
                            <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                                {Object.values(answer).map((key, index) =>
                                    <div tkey={index} className={styles.optionBar}>
                                        <span className={`${styles.indexIconContainer}`}
                                              style={{width: "auto", padding: 5}}>
                                            {t("gradebook.entryNumber", {number: index + 1})}
                                        </span>
                                        {key}
                                    </div>
                                )}
                            </div>
                        }
                    </>
                );
            default:
                return <></>;
        }
    };

    const renderGradeCorrection = () => {
        const { questionType} = selectedQuestion;
        let hasCorrectness = questionHasCorrectness(selectedQuestion);
        if (!hasCorrectness || isManualGradeQue(true, questionType)) {
            return <></>;
        }


        const {attempts=[]} = curResponse;
        const answer = attempts.hasOwnProperty(`${curAttemptNo}`) ? attempts[curAttemptNo][`A${serialNo}`] : null;
        const isAnswered = selectedQuestionResponseStatus.key !== GRADE_BOOK_RESPONSE_STATUS.UNANSWERED.key
            && !!answer
            && answer !== FIXED_ANSWER.UNANSWERED;
        const isActualCorrect = handleUserAns(selectedQuestion, isAnswered ? answer : FIXED_ANSWER.UNANSWERED);

        // const isActualCorrect = checkAnswerCorrect();
        let gradeCorrect = isCorrect();


        if (gradeCorrect !== undefined && isActualCorrect !== gradeCorrect) {
            return (
                <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 8}}>
                    <span  style={{display: "flex", gap: 3}}>
                        <span className={styles.regularLabel}>{t("gradebook.gradeCorrectionLabel")}:</span>
                        <YuJaTooltip text={t("gradebook.gradeCorrectionExplain")} tooltipStyle={{maxWidth: 300}}>
                            <span className={styles.infoIcon}/>
                        </YuJaTooltip>
                    </span>
                    <span className={styles.regularText}>
                        {!!isActualCorrect ? t("gradebook.statusCorrect") : t("gradebook.statusIncorrect")} {"->"} {!!gradeCorrect ? t("gradebook.statusCorrect") : t("gradebook.statusIncorrect")}
                    </span>
                </div>
            );
        }
    }



    const RenderScoreBadge = (question, placement="right") => {
        const {serialNo} = question;
        const {attempts=[]} = curResponse;
        let attempt = attempts[curAttemptNo];
        let actualAnswer = !!attempt ? attempt[`A${serialNo}`] : undefined;
        let formattedResponse = !!attempt ? attempt[`Q${serialNo}`] : undefined;

        let status = getResponseStatus({pollType, pollShareMode, startTime}, question, actualAnswer, formattedResponse);
        let participationPoints = getQuestionParticipationPoints(question);
        let totalPoints = getQuestionWeightage(question);

        if (status.key === GRADE_BOOK_RESPONSE_STATUS.CORRECT.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.correctColor}`}>
                        {t("table.scoreColumn")}: {totalPoints}
                    </span>
                </YuJaTooltip>
            );
        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.PARTIALLY_CORRECT.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.partiallyCorrectColor}`}>
                        {t("table.scoreColumn")}: {participationPoints}
                    </span>
                </YuJaTooltip>
            );
        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.INCORRECT.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.inCorrectColor}`}>
                        {t("table.scoreColumn")}: 0
                    </span>
                </YuJaTooltip>
            );

        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.NON_GRADABLE.key && participationPoints > 0) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.nonGradableColor}`}>
                        {t("table.scoreColumn")}: {participationPoints}
                    </span>
                </YuJaTooltip>
            );
        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.NON_GRADABLE.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.nonGradableColor}`} style={{width: 40}}>
                        <NON_GRADABLE_ICON/>
                    </span>
                </YuJaTooltip>
            );
        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.UN_GRADED.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.ungradedColor}`}>
                        {t("table.scoreColumn")}: {participationPoints}
                    </span>
                </YuJaTooltip>
            );
        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.UNANSWERED.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.unansweredColor}`} style={{width: 40}}>
                        <UN_ANSWERED_ICON/>
                    </span>
                </YuJaTooltip>
            );
        } else if (status.key === GRADE_BOOK_RESPONSE_STATUS.NOT_POSTED.key) {
            return (
                <YuJaTooltip
                    text={t(status.labelKey)}
                    placement={placement}
                    tooltipStyle={{maxWidth: 400}}
                >
                    <span className={`${styles.generalBadge} ${styles.notPostedColor}`} style={{width: 40}}>
                        <NON_POSTED_ICON/>
                    </span>
                </YuJaTooltip>
            );
        } else {
            return <></>;
        }

    }


    const checkAnswerCorrect = () => {
        const {questionType, weightage} = selectedQuestion;


        if (selectedQuestionResponseStatus.key === GRADE_BOOK_RESPONSE_STATUS.UN_GRADED.key) {
            return undefined;
        }

        if (selectedQuestionResponseStatus.key === GRADE_BOOK_RESPONSE_STATUS.CORRECT.key) {
            return true;
        }

        if (selectedQuestionResponseStatus.key === GRADE_BOOK_RESPONSE_STATUS.PARTIALLY_CORRECT.key
            || selectedQuestionResponseStatus.key === GRADE_BOOK_RESPONSE_STATUS.INCORRECT.key
        ) {
            return false;
        }

        if (isManualGradeQue(!!weightage, questionType)) {
            return undefined;
        }

        if (selectedQuestionResponseStatus.key === GRADE_BOOK_RESPONSE_STATUS.UNANSWERED.key) {
            return false;
        }

        return undefined
    }


    const isCorrect = () => {
        const {serialNo} = selectedQuestion;

        if (!!changes
            && changes.hasOwnProperty(`${curUserId}`)
            && changes[curUserId].hasOwnProperty(`${serialNo}`)
            && changes[curUserId][serialNo].hasOwnProperty(`${curAttemptNo}`)
        ) {
            return changes[curUserId][serialNo][curAttemptNo];
        }



        return checkAnswerCorrect();
    }


    const grade = (isCorrect) => {
        const {serialNo} = selectedQuestion;
        if (isCorrect === changes[curUserId]?.[serialNo]?.[curAttemptNo]) {
            return;
        }

        let responseIsCorrect = checkAnswerCorrect();

        let copy = JSON.parse(JSON.stringify(changes));
       if (isCorrect !== responseIsCorrect) {
           setChanges({
               ...copy,
               [curUserId]: {
                   ...copy[curUserId],
                   [serialNo]: {
                       ...copy[curUserId]?.[serialNo],
                       [curAttemptNo]: isCorrect,
                   },
               },
           });
           return;
       }

       if (!!copy[curUserId]?.[serialNo] && copy[curUserId]?.[serialNo].hasOwnProperty(`${curAttemptNo}`)) {
           delete copy[curUserId][serialNo][curAttemptNo];
           if (!Object.keys(copy[curUserId][serialNo]).length) {
               delete copy[curUserId][serialNo];
           }

           if (!Object.keys(copy[curUserId]).length) {
               delete copy[curUserId];
           }

           setChanges(copy);
       }
    };

    const canPrevious = () => {
        return students[0].value !== curUserId;
    }

    const canNext = () => {
        return students[students.length - 1].value !== curUserId;
    }

    const goPrevious = () => {
        let idx = students.map(stu => stu.value).indexOf(curUserId);
        setCurUserId(students[idx - 1].value);
        setCurAttemptNo(1);
    }

    const goNext = () => {
        let idx = students.map(stu => stu.value).indexOf(curUserId);
        setCurUserId(students[idx + 1].value);
        setCurAttemptNo(1);
    }


    const goBack = () => {
        if (Object.keys(changes).length === 0) {
            setOpen(false);
            return;
        }

        setGradeAlertShow(true);
    }


    const onSave = async () => {
        if (!changes || Object.keys(changes).length === 0 ) {
            return;
        }

        setIsSaving(true);
        try {
            let selectedOptions = {};
            for (const user of Object.keys(changes)) {
                let response = responses.find(r => r.userId === user);
                if (!response) {
                    continue;
                }
                for (const questionNo of Object.keys(changes[user])) {
                    for (const attemptNo of Object.keys(changes[user][questionNo])) {
                        selectedOptions = {
                            ...selectedOptions,
                            [user]: {
                                ...selectedOptions[user],
                                [questionNo]: {
                                    ...selectedOptions[user]?.[questionNo],
                                    [attemptNo]: {
                                        // answer: getAnswer(response, attemptNo, questionNo), // Fetch answer for the attempt and question
                                        isCorrect: changes[user][questionNo][attemptNo], // Use correctness information from changedCorrect state
                                    },
                                },
                            },
                        };
                    }
                }
            }
            await gradeQuestionStudents(institutionId, pollKey, pollCode, changes, questions, selectedOptions);
            setChanges({});
            setOpen(false);
            notifySuccess(t("gradebook.saveGradesSuccess"));
            await loadData();
        } catch (error) {
            console.log(error);
            notifyError(t("gradebook.saveChangesError"));
        } finally {
            setIsSaving(false);
        }
    };


    const renderFooter = () => {
        if (GRADE_BOOK_RESPONSE_STATUS.NOT_POSTED.key === selectedQuestionResponseStatus.key) {
            return (
                <div style={{flex: 1, minWidth: 0}}>
                    <div className={styles.regularLabel}>{t("gradebook.unableToGradeQuestion")}</div>
                    <div style={{height: 5}}/>
                    <div className={styles.regularText} style={{
                        color: "#6B6B6B",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}>
                        {t("gradebook.unableToGradeQuestionExplain")}
                    </div>
                </div>
            );
        }

        if (!questionHasCorrectness(selectedQuestion)) {
            return (
                <div style={{flex: 1, minWidth: 0}}>
                    <div className={styles.regularLabel}>{t("gradebook.nonGradableQuestion")}</div>
                    <div style={{height: 5}}/>
                    <div className={styles.regularText} style={{
                        color: "#6B6B6B",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}>
                        {
                            questionHasWeightage(selectedQuestion)
                            ? t("gradebook.nonGradableQuestionAppliedExplain") //has participation points
                            : t("gradebook.nonGradableQuestionExplain")
                        }
                    </div>
                </div>
            );
        } else {
            return (
                <>
                    <div style={{flex: 1, minWidth: 0}}>
                        <div className={styles.regularLabel}>{t("gradebook.gradeQuestionLabel")}</div>
                        <div style={{height: 5}}/>
                        <div
                            className={styles.regularText}
                            style={{
                                color: "#6B6B6B",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis"
                            }}
                        >
                            {t("gradebook.gradeQuestionExplain")}
                        </div>
                    </div>
                    <YuJaRadioBox
                        value="correct"
                        name="isCorrect"
                        label={t("gradebook.statusCorrect")}
                        onClick={() => grade(true)}
                        checked={isCorrect() === true}
                    />
                    <YuJaRadioBox
                        value="incorrect"
                        name="isCorrect"
                        label={t("gradebook.statusIncorrect")}
                        onClick={() => grade(false)}
                        checked={isCorrect() === false}
                    />
                </>
            );
        }
    }


    return (
        <GradeQuestionWrapper>
            <YuJaGeneralAlert
                show={alertGradeShow}
                setModalShow={setGradeAlertShow}
                content={t("poll.unsavedChangesContent")}
                config={gradeAlertConfig}
            />

            {open &&
                <div ref={parentContainerRef} className={styles.mask}>
                    <div className={styles.parentContainer}>
                        <div className={styles.containerRow} style={{gap: 10}}>
                            <Button  className={styles.goBack} onClick={goBack}>
                                <GO_BACK style={{flexShrink: 0}}/>
                                <span style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}>{t("common.back")}</span>
                            </Button>

                            <span style={{flex: 1}}/>

                            <YuJaButton
                                disabled={!canPrevious()}
                                onClick={goPrevious}
                                style={{
                                    width: 32, height: 32, marginRight: 10,
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }}
                            >
                                <ARROW_LEFT_ICON/>
                            </YuJaButton>

                            {/*<YuJaDropdown*/}
                            {/*    style={{width: 250}}*/}
                            {/*    size={"small"}*/}
                            {/*    data={students}*/}
                            {/*    value={curUserId}*/}
                            {/*    searchAble={true}*/}
                            {/*    searchPlaceholder={SEARCH_BY_PARTICIPANT_TEXT}*/}
                            {/*    onChange={option => {*/}
                            {/*        setCurUserId(option.value);*/}
                            {/*        setCurAttemptNo(1);*/}
                            {/*    }}*/}
                            {/*/>*/}

                            <YuJaComboBox
                                options={students}
                                value={curUserId}
                                searchPlaceholder={t("gradebook.searchByParticipant")}
                                style={{width: 250}}
                                size={"small"}
                                onChange={opt => {
                                    setCurUserId(opt.value);
                                    setCurAttemptNo(1);
                                }}

                            />

                            <YuJaButton
                                disabled={!canNext()}
                                onClick={goNext}
                                style={{
                                    width: 32, height: 32, marginLeft: 10,
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }}
                            >
                                <ARROW_RIGHT_ICON/>
                            </YuJaButton>


                            <span style={{flex: 1}}/>
                            {!!hasCorrectness(questions) && pollType.toUpperCase() !== POLL_TYPE.SURVEY &&
                                <YuJaButton
                                    disabled={isSaving || !Object.keys(changes).length}
                                    style={{
                                        minWidth: 90,
                                        flexShrink: 0,
                                        height: 35,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                    onClick={onSave}
                                >
                                    {isSaving
                                        ?
                                        <img src={loadingGif} alt={"loading..."} style={{height: 20}}/>
                                        :
                                        <>
                                            <SAVE style={{marginRight: 5}}/> {t("common.save")}
                                        </>
                                    }
                                </YuJaButton>
                            }
                        </div>
                        <div className={styles.containerRow} style={{gap: 10}}>
                            {!!curResponse.hasOwnProperty("attempts") && !!Object.keys(curResponse.attempts).length &&
                                <>
                                    <span style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "500"}}>
                                        {t("gradebook.participantAttemptLabel")}
                                    </span>
                                    <YuJaSelect
                                        options={
                                            Object.keys(curResponse.attempts)
                                                .filter(key => key !== '0')
                                                .map(key => ({label: t("gradebook.attemptNumber", {number: key}), value: parseInt(key)}))
                                        }
                                        value={curAttemptNo}
                                        onChange={val => setCurAttemptNo(val)}
                                        placeholder={t("gradebook.selectAttempt")}
                                        size={"small"}
                                        style={{width: 150}}
                                    />
                                    <div style={{flex: 1}}/>
                                    <span
                                        className={styles.generalBadge}
                                        style={{
                                            width: 140,
                                            backgroundColor: "#F8DCDB",
                                            flexShrink: 0
                                        }}
                                    >
                                        {t("questionBank.questionsHeader")}: {questions.length}
                                    </span>


                                    {!!hasWeightage(questions) && pollType.toUpperCase() !== POLL_TYPE.SURVEY
                                        && width > RESPONSIVE_SIDE_BAR_POINT &&
                                        <span
                                            className={styles.generalBadge}
                                            style={{
                                                width: "fit-content",
                                                padding: "0 10px",
                                                backgroundColor: "#E4E3F6",
                                                flexShrink: 0
                                            }}
                                        >
                                           {t("poll.scoreText")}: {scored}
                                        </span>
                                    }

                                    {!!hasWeightage(questions) && pollType.toUpperCase() !== POLL_TYPE.SURVEY &&
                                        <span
                                            className={styles.generalBadge}
                                            style={{
                                                width: 140,
                                                whiteSpace: "nowrap",
                                                padding: "0 10px",
                                                backgroundColor: "#F9E4F5",
                                                flexShrink: 0
                                            }}
                                        >
                                            {t("gradebook.gradeLabel")}: {`${percentage}%`}
                                        </span>
                                    }
                                </>
                            }

                            {(!curResponse.hasOwnProperty("attempts") || !Object.keys(curResponse.attempts).length) &&
                                <>
                                    <span style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
                                        {t("gradebook.studentAttempt")}
                                    </span>
                                    {/*<YuJaDropdown*/}
                                    {/*    data={[1]}*/}
                                    {/*    placeholder={"Select an Attempt"}*/}
                                    {/*    getOptionLabel={option => "Attempt " + option}*/}
                                    {/*    getOptionValue={option => option}*/}
                                    {/*    value={curAttemptNo}*/}
                                    {/*    onChange={(option) => setCurAttemptNo(option)}*/}
                                    {/*    style={{width: 150}}*/}
                                    {/*    size={"small"}*/}
                                    {/*/>*/}
                                    <YuJaSelect
                                        options={
                                            Object.keys(curResponse.attempts)
                                                .filter(key => key !== '0')
                                                .map(key => ([{label: t("gradebook.attempt1"), value: 1}]))
                                        }
                                        value={curAttemptNo}
                                        onChange={val => setCurAttemptNo(val)}
                                        placeholder={t("gradebook.selectAttempt")}
                                        size={"small"}
                                        style={{width: 150}}
                                    />

                                    <div style={{flex: 1}}/>
                                    <span className={styles.generalBadge}
                                          style={{width: 140, backgroundColor: "#F8DCDB", flexShrink: 0}}>
                                        {t("questionBank.questionsHeader")}: {questions.length}
                                    </span>
                                    {!!hasWeightage(questions) && pollType.toUpperCase() !== POLL_TYPE.SURVEY
                                        && width > RESPONSIVE_SIDE_BAR_POINT &&
                                        <span
                                            className={styles.generalBadge}
                                            style={{
                                                width: "fit-content",
                                                padding: "0 10px",
                                                backgroundColor: "#E4E3F6",
                                                flexShrink: 0
                                            }}
                                        >
                                           {t("poll.scoreText")}: 0/{totalScore}
                                        </span>
                                    }

                                    {!!hasWeightage(questions) && pollType.toUpperCase() !== POLL_TYPE.SURVEY &&
                                        <span
                                            className={styles.generalBadge}
                                            style={{
                                                width: 140,
                                                padding: "0 10px",
                                                backgroundColor: "#F9E4F5",
                                                flexShrink: 0
                                            }}
                                        >
                                            {t("gradebook.gradeLabel")}: 0%
                                        </span>
                                    }
                                </>
                            }
                        </div>

                        <div className={styles.body}>
                            <div className={styles.questionList}>
                                {questions.map((que, index) => (
                                    <div
                                        tabIndex={0}
                                        key={index}
                                        className={`${styles.questionCard} ${que.serialNo === selectedSerialNo ? styles.active : ""}`}
                                        onClick={() => setSelectedSerialNo(que.serialNo)}
                                    >
                                        <div style={{display: "flex", alignItems: "center", width: "100%"}}>
                                            <span className={styles.questionNoLabel}
                                                  style={{flexShrink: 0}}>{t("common.questionLabel")} {que.serialNo}</span>
                                            <div style={{flex: 1}}/>
                                            {RenderScoreBadge(que)}
                                        </div>
                                        <div className={styles.questionType}>{questionCodeToName(que.questionType)}</div>
                                    </div>
                                ))}
                            </div>

                            <div style={{flex: 1, minWidth: 0, display: "flex", flexDirection: "column", height: "100%"}}>
                                <div className={styles.questionMainContainer}>
                                    <div className={styles.questionMainContainerRow} style={{gap: 10}}>
                                        <span className={styles.questionNoLabel}>{t("accessibility.questionPrefix")} {selectedQuestion.serialNo}</span>
                                        <span style={{flex: 1}}/>
                                        {questionHasWeightage(selectedQuestion) &&
                                            <YuJaTooltip
                                                disableTab={true}
                                                placement={"bottom"}
                                                disabled={!getQuestionParticipationPoints(selectedQuestion)}
                                                text={parse(
                                                    `<span>
                                                        ${getQuestionCorrectnessPoints(selectedQuestion)} ${t("questionBuilder.correctnessPointsLabel")}</br> 
                                                        ${getQuestionParticipationPoints(selectedQuestion)} ${t("questionBuilder.participationPointsLabel")}</span>`
                                                )}
                                            >
                                                <span
                                                    className={styles.generalBadge}
                                                    style={{
                                                        width: "fit-content",
                                                        padding: "0 10px",
                                                        backgroundColor: "#F8E4DD",
                                                        flexShrink: 0
                                                    }}
                                                >
                                                   {t("poll.customizePointsLabel")}: {getQuestionWeightage(selectedQuestion)}
                                                </span>
                                            </YuJaTooltip>
                                        }
                                        {RenderScoreBadge(selectedQuestion, "bottom")}
                                    </div>

                                    <span className={styles.questionType}>
                                        {questionCodeToName(selectedQuestion.questionType)}
                                    </span>


                                    <span className={styles.regularText} style={{display: "flex", gap: 5, alignItems: "center"}}>
                                        <span className={styles.regularLabel} >{t("common.questionColonLabel")}</span>
                                        {selectedQuestion.questionType !== QUESTION_TYPES.FITB.name &&
                                            <LatexInline>{selectedQuestion.queTitle}</LatexInline>
                                        }

                                        {selectedQuestion.questionType === QUESTION_TYPES.FITB.name &&
                                            <>{selectedQuestion.queTitle.replace(BLANK_REGEX, "______")}</>
                                        }
                                    </span>


                                    {questionImageURL && selectedQuestion.questionType === QUESTION_TYPES.CI.name &&
                                        <div className={`${styles.questionImgContainer}`}>
                                            <div style={{position: "relative"}}>
                                                {!isLoaded &&
                                                    <SkeletonTheme color="rgba(237, 237, 237, 1)"
                                                                   highlightColor="lightgrey">
                                                        <div >
                                                            <Skeleton borderRadius={10} height={150} width={200}/>
                                                        </div>
                                                    </SkeletonTheme>
                                                }

                                                <img
                                                    style={{maxWidth: "100%", maxHeight: "100%", visibility: isLoaded ? undefined : "hidden"}}
                                                    src={questionImageURL}
                                                    alt={t("common.questionLabel")}
                                                    onLoad={onLoad}
                                                />

                                                {isLoaded && selectedQuestion.optionsMap.map((area, idx) =>
                                                    <div key={idx} style={{
                                                        width: decodeCIParam(area.width, imageWidth),
                                                        height: decodeCIParam(area.height, imageHeight),
                                                        left: decodeCIParam(area.x, imageWidth),
                                                        top: decodeCIParam(area.y, imageHeight),
                                                        position: "absolute",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        border: "solid #009883 1.5px",
                                                        borderRadius: "4px",
                                                        color: "#009883",
                                                        fontWeight: "400",
                                                        fontSize: "15px",
                                                        backgroundColor: "rgba(246, 255, 254, 0.9)",
                                                        boxShadow: "0px 0px 5px 0px #00000026"
                                                    }}>
                                                        {String.fromCharCode(ASCII_CODE_A + idx)}
                                                    </div>
                                                )}
                                            </div>


                                        </div>
                                    }

                                    {questionImageURL && selectedQuestion.questionType !== QUESTION_TYPES.CI.name && !isVideo &&
                                        <div className={`${styles.questionImgContainer}`}>
                                            {!isLoaded &&
                                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                                    <Skeleton borderRadius={10} height={150} width={200} />
                                                </SkeletonTheme>
                                            }

                                            {!isVideo &&
                                                <img
                                                    style={{maxWidth: "100%", maxHeight: "100%", display: isLoaded ? undefined : "none"}}
                                                    src={questionImageURL}
                                                    alt={t("common.questionLabel")}
                                                    onLoad={onLoad}
                                                />
                                            }
                                        </div>
                                    }

                                    {!!questionImageURL && !!isVideo &&
                                        <>
                                            {!isLoaded &&
                                                <SkeletonTheme color="rgba(237, 237, 237, 1)"
                                                               highlightColor="lightgrey">
                                                    <Skeleton borderRadius={10} height={150} width={200}/>
                                                </SkeletonTheme>
                                            }
                                            <iframe allowFullScreen src={questionImageURL} width={350} height={250}
                                                    style={{display: isLoaded ? undefined : "none"}}
                                                    onLoad={onLoad}/>
                                        </>
                                    }

                                    {renderAnswer()}

                                    {renderGradeCorrection()}
                                </div>

                                <div className={styles.questionMainContainerFooter}>
                                    {renderFooter()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </GradeQuestionWrapper>
    );
}


const GradeQuestionWrapper = ({children}) => {
    const [wrapper, ] = useState(() => {
        const div = document.createElement("div");
        div.id = `YuJa_Grade_Question_${Date.now().toString()}`;
        return div;

    });
    useEffect(() => {
        const rootEle = document.getElementById('root');
        rootEle.appendChild(wrapper);

        return () => {
            if (wrapper) {
                wrapper.remove();
            }
        }
    }, []);



    return ReactDOM.createPortal(children, wrapper);

};
